module.exports = [{
      plugin: require('/home/baboo/Documents/projets/privilege-revival/front/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
